import { makeRequest } from './Storefront'

export const productGallery = (swiperElement, thumbElement, swiperType = 'small', imageId = null) => {
  const gallerySlideCount = swiperElement.querySelectorAll(
    '.swiper-wrapper > .swiper-slide:not(.swiper-slide-duplicate)',
  ).length
  const shouldLoop = gallerySlideCount > 5

  const syncThumbSlideIndexes = () => {
    thumbElement?.querySelectorAll('.swiper-slide[data-gallery-index]').forEach((slide) => {
      slide.setAttribute('data-swiper-slide-index', slide.dataset.galleryIndex)
    })
  }
  const thumbSwiper = thumbElement
    ? new Swiper(thumbElement, {
        loop: shouldLoop,
        slidesPerView: 'auto',
        spaceBetween: 8,
        freeMode: true,
        watchSlidesProgress: true,
        keyboard: {
          enabled: true,
          onlyInViewport: false,
        },
      })
    : null
  if (thumbSwiper) {
    syncThumbSlideIndexes()
    thumbSwiper.on('loopFix update resize tap', syncThumbSlideIndexes)
  }
  const mainSwiper = new Swiper(swiperElement, {
    speed: 500,
    effect: 'fade',
    loop: shouldLoop,
    slidesPerView: 1,
    allowTouchMove: true,
    breakpoints: {
      320: {
        allowTouchMove: true,
      },
      1024: {
        allowTouchMove: false,
      },
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
    },
    navigation:
      swiperType == 'small'
        ? false
        : {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
    thumbs: thumbSwiper
      ? {
          swiper: thumbSwiper,
        }
      : false,
    breakpoints: {
      320: {
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
        },
      },
      1024: {
        pagination: false,
      },
    },
  })
  if (imageId) {
    const slideIndex = swiperElement.querySelector(`[data-media-id="${imageId}"]`).dataset.index
    mainSwiper.params.loop ? mainSwiper.slideToLoop(Number(slideIndex)) : mainSwiper.slideTo(slideIndex)
  }
  return mainSwiper
}

const productJson = (apiProduct) => {
  return {
    id: apiProduct.id,
    handle: apiProduct.handle,
    tags: apiProduct.tags,
    title: apiProduct.title,
    media: apiProduct.media.edges.map((edge) => {
      return {
        alt: edge.node.alt,
        preview_image: { src: edge.node.previewImage.url },
        media_type: edge.node.mediaContentType,
      }
    }),
    price: parseFloat(apiProduct.variants.edges[0].node.price.amount) * 100,
    comparePrice: apiProduct.variants.edges[0].node.compareAtPrice
      ? parseFloat(apiProduct.variants.edges[0].node.compareAtPrice.amount) * 100
      : null,
    options_by_name: apiProduct.options[0].name == 'Color' ? { Color: true } : {},
    siblings:
      typeof apiProduct.collections != 'undefined' &&
      apiProduct.collections.edges.filter((edge) => edge.node.title.includes('_linked')).length
        ? apiProduct.collections.edges
            .filter((edge) => edge.node.title.includes('_linked'))[0]
            .node.products.edges.filter((edge) => edge.node.onlineStoreUrl)
            .map((edge) => ({
              sku: edge.node.variants.edges[0].node.sku,
              colorName:
                edge.node.variants.edges[0].node.selectedOptions?.find((o) => o.name === 'Color')?.value ||
                edge.node.variants.edges[0].node.title,
            }))
        : [],
    variants: apiProduct.variants.edges.map((edge) => edge.node),
    collectionLoaded: typeof apiProduct.collections != 'undefined' ? true : false,
  }
}

const simpleProductResponse = `
  id
  title
  handle
  tags
  onlineStoreUrl
  media (first: 9) {
    edges {
      node {
        alt
        mediaContentType
        previewImage {
          url
        }
      }
    }
  }
  options (first: 1) {
    name
  }
  variants (first: 1) {
    edges {
      node {
        id
        availableForSale
        selectedOptions { name value }
        price {
          amount
        }
        compareAtPrice {
          amount
        }
      }
    }
  }
`
const productCollectionsResponse = `
  collections (first: 30) {
    edges {
      node {
        id
        title
        products (first: 180) {
          edges {
            node {
              onlineStoreUrl
              variants (first: 1) {
                edges {
                  node {
                    sku
                    title
                    selectedOptions { name value }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
const productResponse = `
  ${simpleProductResponse}
  ${productCollectionsResponse}
`
export const getXgenProducts = (callback = null, skus = []) => {
  console.log('skus', skus)
  const query = `{
    products (first: 50, query: "${skus.join(' OR ')}" ) {
      edges {
        node {
          ${simpleProductResponse}
        }
      }
    }
  }`
  makeRequest((results) => {
    // callback(results)
    callback(results.data.products.edges.map((edge) => productJson(edge.node)))
  }, query)
}

export const getProductsByIds = (callback = null, ids = []) => {
  const query = `{
    nodes(ids: [${ids.join(',')}]) {
      ...on Product {
        ${simpleProductResponse}
      }
    }
  }`
  makeRequest((results) => {
    callback(results.data.nodes.filter((node) => node != null).map((node) => productJson(node)))
  }, query)
}

export const getProductsByHandles = (callback = null, handles = []) => {
  let query = `{`
  handles.forEach((handle, index) => {
    query += `
      product${index}: productByHandle(handle: ${handle}) {
        ${simpleProductResponse}
      }
    `
  })
  query += `}`
  if (query == '{}') callback([])
  else {
    makeRequest((results) => {
      callback(
        Object.entries(results.data)
          .filter(([key, value]) => value != null)
          .map(([key, value]) => productJson(value)),
      )
      // callback(results.data.nodes.filter((node) => node != null).map((node) => productJson(node)))
    }, query)
  }
}

export const getProductCollections = (callback = null, id) => {
  const query = `
    query getProductById($id: ID!) {
      product(id: $id) {
        ${productCollectionsResponse}
      }
    }
  `
  const variables = { id }
  makeRequest(
    (results) => {
      if (callback) callback(results.data.product)
    },
    query,
    variables,
  )
}
